// Pages
import { Batche } from "./Batche";
import { Proposal } from "./Proposal";
import { Table } from "./Table";

export const Batches = {
    Table: (): JSX.Element => <Table />,
    Proposal: (): JSX.Element => <Proposal />,
    Batche: (): JSX.Element => <Batche />
}